import { GqlQueryOptions, GqlServiceV2 } from '../modules/content/service/gql.service-v2';
import { Injectable } from '@angular/core';
import { GridInput } from '@it2go/data-grid';
import { filterFrag } from './types/filter.types';
import { DiagnosisGridObject, OkObject } from '@it2go/types';
import { IdInput } from '@libs/types/src/common/input-type/id.input';
import {
    DiagnosisBonificationCreateInput,
} from '@libs/types/src/services/input-type/diagnosis/diagnosis-bonification.create-input';
import {
    DiagnosisBonificationGridObject,
    DiagnosisBonificationObject,
} from '@libs/types/src/services/object-type/diagnosis/diagnosis-bonification.object';
import {
    DiagnosisBonificationUpdateInput,
} from '@libs/types/src/services/input-type/diagnosis/diagnosis-bonification.update-input';

@Injectable({ providedIn: 'root' })
export class DiagnosisGqlService extends GqlServiceV2 {

    public async getDiagnoses(input: GridInput, fragment: string, options: GqlQueryOptions = {}) {
        return this.query<DiagnosisGridObject>(
            `
                query($input: GridInput) {
                    diagnosis {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${fragment}
                            }
                        }
                    }
                }
            `,
            { input },
            options,
        );
    }

    public async getDiagnosisBonifications(input: GridInput, fragment: string) {
        return this.query<DiagnosisBonificationGridObject>(
            `
                query($input: GridInput) {
                    diagnosisBonification {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${fragment}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public async createDiagnosisBonification(
        input: DiagnosisBonificationCreateInput,
        fragment: string,
    ) {
        return this.mutate<DiagnosisBonificationObject>(
            `
                mutation($input: DiagnosisBonificationCreateInput!) {
                    diagnosisBonification {
                        create(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public async updateDiagnosisBonification(
        input: DiagnosisBonificationUpdateInput,
        fragment: string,
    ) {
        return this.mutate<DiagnosisBonificationObject>(
            `
                mutation($input: DiagnosisBonificationUpdateInput!) {
                    diagnosisBonification {
                        update(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public async deleteDiagnosisBonification(input: IdInput, fragment: string = 'ok') {
        return this.mutate<OkObject>(
            `
                mutation($input: IdInput!) {
                    diagnosisBonification {
                        delete(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

}
